import * as React from "react";

import i18next from "i18next";

import { IconWrapper, Nav, StyledNavLink } from "./styles";
import { FileIcon } from "../../svg";

const FinancialInfoNavItem = ({ isVisible }: { isVisible: boolean }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Nav.Item>
      <StyledNavLink to="/financial-info">
        <IconWrapper>
          <FileIcon />
        </IconWrapper>
        {i18next.t("title_financial_info")}
      </StyledNavLink>
    </Nav.Item>
  );
};

export default FinancialInfoNavItem;
